/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.OMS {
    var x;
    @Serenity.Decorators.registerClass()
    export class ProductPartyDetailsEditor extends _Ext.GridEditorBase<ProductPartyDetailsRow> {
        protected getColumnsKey() { return "OMS.ProductPartyDetails"; }
        protected getDialogType() { return ProductPartyDetailsDialog; }
        protected getLocalTextPrefix() { return ProductPartyDetailsRow.localTextPrefix; }
         
        protected form: ProductPartyDetailsForm;

        
        constructor(container: JQuery) { 
            super(container); 


        }
        protected validateEntity(row: ProductPartyDetailsRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;


            //duplicate Component
            row.PartyId = Q.toId(row.PartyId);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.PartyId === row.PartyId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Party is already in Details!');
                return false;
            }
             AccountLedgerService.Retrieve({ EntityId: row.PartyId }, response => {
                if (response.Entity != null) {


                    row.PartyCode = response.Entity.PartyCode;
                    row.LedgerName = response.Entity.LedgerName;
                 }
             }, { async: false })

            //update values in grid
            return true;
        }

    }
}